import type { MessageHome } from './message-homes'

// Meaning squares, Liam's Messages M4 family (1 Nov 2026). No runtime dependencies, shared by every screen.
const SYMBOLS: Record<MessageHome, readonly string[]> = {
  enquiries: ['M12 5v14M5 12h14'],
  comingup: ['M5 5h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z', 'M3 10h18M8 3v4M16 3v4'],
  late: ['M7 3h10M7 21h10', 'M8 3c0 5 8 5 8 9s-8 4-8 9M16 3c0 5-8 5-8 9s8 4 8 9'],
  waiting: ['M4.5 4h15A1.5 1.5 0 0 1 21 5.5v10a1.5 1.5 0 0 1-1.5 1.5H11l-5 4v-4H4.5A1.5 1.5 0 0 1 3 15.5v-10A1.5 1.5 0 0 1 4.5 4z'],
}

export function meaningIcon(home: MessageHome, size: 'tile' | 'row'): HTMLElement {
  const square = document.createElement('span')
  square.className = `meaning-icon meaning-icon-${home} meaning-icon-${size}`
  square.setAttribute('aria-hidden', 'true')
  const ns = 'http://www.w3.org/2000/svg'
  const svg = document.createElementNS(ns, 'svg')
  svg.setAttribute('viewBox', '0 0 24 24')
  svg.setAttribute('width', size === 'tile' ? '26' : '22')
  svg.setAttribute('height', size === 'tile' ? '26' : '22')
  svg.setAttribute('fill', 'none')
  svg.setAttribute('stroke', 'currentColor')
  svg.setAttribute('stroke-width', '2.5')
  svg.setAttribute('stroke-linecap', 'round')
  svg.setAttribute('stroke-linejoin', 'round')
  for (const d of SYMBOLS[home]) {
    const path = document.createElementNS(ns, 'path')
    path.setAttribute('d', d)
    if (home === 'waiting') path.setAttribute('fill', 'var(--brand-surface)')
    svg.append(path)
  }
  if (home === 'waiting') for (const x of [8, 12, 16]) {
    const dot = document.createElementNS(ns, 'circle')
    dot.setAttribute('cx', String(x)); dot.setAttribute('cy', '10.5'); dot.setAttribute('r', '1.5')
    dot.setAttribute('fill', 'currentColor'); dot.setAttribute('stroke', 'none')
    svg.append(dot)
  }
  square.append(svg)
  return square
}
